module.exports = __webpack_public_path__ + "static/media/SIEMENS_F1.15933bb0.txt";